import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {seedQuestionSourceSchema} from './SeedQuestionSource';
import {seedQuestionStatusSchema} from './SeedQuestionStatus';

export const seedQuestionSchema = z.object({
  id: z.string(),
  questionText: z.string(),
  topic: z.string(),
  options: z.array(z.string()),
  answer: z.string(),
  source: seedQuestionSourceSchema,
  status: seedQuestionStatusSchema.optional(),
  createdAt: firestoreTimestampToDateSchema,
});

export interface SeedQuestion extends z.infer<typeof seedQuestionSchema> {}
